<template>
<div class="message-wrap">
  <span>
    <img src="/img/help_txt_icon.svg" alt="">
  </span>
  <p v-html="message"></p>
</div>
</template>

<script>
/* 2021.04.13 - Nam Sang Woo
 * app-message 컴포넌트 
 * params: message 
 * description: messaged에 i18n 텍스트를 담아서 보여줌(행)
 */ 
export default {
	name: "appHelpMessage",
	props: {
		message: {
			type: String,
      default: ""
		},
	},
	data() {
		return {
		};
	},
};
</script>

<style lang="scss" scoped>
	.message-wrap{
		display: flex;
		flex-flow: row nowrap;
		align-items: flex-start;
		padding:6px 0;
	}
	span{
		width: 14px;
		height: 14px;
		box-sizing: border-box;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: center;
		border:1px solid #F7685B;
		border-radius: 100%;
		margin-right: 5px;
	}
	p{
		color: #F7685B;
		font-size: 11px;
		text-align: left;
		font-weight: 400;
		margin:0;
		line-height: 1.3;
		margin-top:1px;
		flex:1;
	}
</style>